var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DemoBase',{attrs:{"size":"xs4"}},[_vm._v(" Date Range Picker "),_c('DateRangePicker'),_vm._v(" Start & End date "),_c('DateRangePicker',{attrs:{"starting-date":"2022-10-05","ending-date":"2022-11-05"},on:{"onPicked":_vm.onPicker}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }